import React from "react";
import { restaurantInfo } from "../data/mock";
import { MapPin, Clock, Phone, Star, Globe } from "lucide-react";

export default function InfoBlock() {
  return (
    <section id="contact" className="py-24 md:py-32 border-t border-b border-[var(--mm-line)]">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12">
        {/* Rating strip */}
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4 mb-16 fade-in">
          <div className="flex items-center gap-2">
            <Star size={18} className="fill-[var(--mm-accent)] text-[var(--mm-accent)]" />
            <span className="font-display text-2xl text-[var(--mm-cream)]">{restaurantInfo.rating.google.score}</span>
            <span className="text-xs tracking-[0.24em] uppercase text-[var(--mm-cream-muted)]">Google · {restaurantInfo.rating.google.count} reviews</span>
          </div>
          <div className="h-6 w-px bg-[var(--mm-line)] hidden md:block" />
          <div className="flex items-center gap-2">
            <Star size={18} className="fill-[var(--mm-accent)] text-[var(--mm-accent)]" />
            <span className="font-display text-2xl text-[var(--mm-cream)]">{restaurantInfo.rating.ubereats.score}</span>
            <span className="text-xs tracking-[0.24em] uppercase text-[var(--mm-cream-muted)]">Uber Eats · {restaurantInfo.rating.ubereats.count}+ reviews</span>
          </div>
          <div className="h-6 w-px bg-[var(--mm-line)] hidden md:block" />
          <div className="flex items-center gap-2 px-3 py-1 border border-[var(--mm-accent)] rounded-full">
            <span className="text-xs tracking-[0.24em] uppercase text-[var(--mm-accent)] font-semibold">100% Halal</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-14 md:gap-8">
          {/* Address */}
          <div className="fade-in">
            <div className="flex items-center gap-3 mb-6">
              <MapPin size={16} className="text-[var(--mm-accent)]" />
              <span className="section-label">Address</span>
            </div>
            <div className="font-display text-2xl md:text-3xl text-[var(--mm-cream)] leading-tight">
              {restaurantInfo.address.line1}
              <br />
              {restaurantInfo.address.line2}
            </div>
            <a
              href={restaurantInfo.address.mapUrl}
              target="_blank"
              rel="noreferrer"
              className="link-underline mt-6 inline-block text-[var(--mm-accent)] text-xs tracking-[0.28em] uppercase"
            >
              Get Directions
            </a>
            <a
              href={restaurantInfo.website}
              target="_blank"
              rel="noreferrer"
              className="link-underline mt-3 flex items-center gap-2 text-[var(--mm-cream-muted)] hover:text-[var(--mm-accent)] transition-colors text-sm"
            >
              <Globe size={14} /> mamaminassoulfeed.online
            </a>
          </div>

          {/* Hours */}
          <div className="fade-in">
            <div className="flex items-center gap-3 mb-6">
              <Clock size={16} className="text-[var(--mm-accent)]" />
              <span className="section-label">Hours</span>
            </div>
            <div className="space-y-2">
              {restaurantInfo.hours.map((h, i) => (
                <div key={i} className="flex justify-between items-baseline gap-4 py-1 border-b border-[var(--mm-line)] last:border-0">
                  <span className="font-display text-lg text-[var(--mm-cream)]">{h.label}</span>
                  <span className="text-sm text-[var(--mm-cream-muted)]">{h.time}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div className="fade-in">
            <div className="flex items-center gap-3 mb-6">
              <Phone size={16} className="text-[var(--mm-accent)]" />
              <span className="section-label">Contact</span>
            </div>
            <a
              href={`tel:${restaurantInfo.contact.phone}`}
              className="font-display text-2xl md:text-3xl text-[var(--mm-cream)] block hover:text-[var(--mm-accent)] transition-colors"
              data-testid="info-phone"
            >
              {restaurantInfo.contact.phoneDisplay}
            </a>
            <a
              href={`tel:${restaurantInfo.contact.mobile}`}
              className="text-[var(--mm-cream-muted)] text-sm mt-1 block hover:text-[var(--mm-accent)] transition-colors"
              data-testid="info-mobile"
            >
              or {restaurantInfo.contact.mobileDisplay}
            </a>
            <a
              href={`mailto:${restaurantInfo.contact.email}`}
              className="text-[var(--mm-cream-muted)] mt-2 block hover:text-[var(--mm-accent)] transition-colors"
            >
              {restaurantInfo.contact.email}
            </a>
            <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2">
              <a href={restaurantInfo.social.instagram} target="_blank" rel="noreferrer" className="link-underline text-xs tracking-[0.28em] uppercase text-[var(--mm-accent)]">Instagram</a>
              <a href={restaurantInfo.social.facebook} target="_blank" rel="noreferrer" className="link-underline text-xs tracking-[0.28em] uppercase text-[var(--mm-accent)]">Facebook</a>
              <a href={restaurantInfo.social.tiktok} target="_blank" rel="noreferrer" className="link-underline text-xs tracking-[0.28em] uppercase text-[var(--mm-accent)]">TikTok</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
